import { render, staticRenderFns } from "./FairAdressCard.vue?vue&type=template&id=289e3250&"
import script from "./FairAdressCard.vue?vue&type=script&lang=js&"
export * from "./FairAdressCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports